import { render } from "./ApprovePR.vue?vue&type=template&id=34516a46"
import script from "./ApprovePR.vue?vue&type=script&lang=js"
export * from "./ApprovePR.vue?vue&type=script&lang=js"

import "./ApprovePR.vue?vue&type=style&index=0&id=34516a46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__